var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderManagementLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 6.625C5.75 6.97019 6.02981 7.25 6.375 7.25H10.125C10.4702 7.25 10.75 6.97019 10.75 6.625C10.75 6.27981 10.4702 6 10.125 6H6.375C6.02981 6 5.75 6.27981 5.75 6.625Z",
    fill: "#53AEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8.5H6.375C6.02981 8.5 5.75 8.77981 5.75 9.125C5.75 9.47019 6.02981 9.75 6.375 9.75H10.125C10.4702 9.75 10.75 9.47019 10.75 9.125C10.75 8.77981 10.4702 8.5 10.125 8.5Z",
    fill: "#53AEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 11H6.375C6.02981 11 5.75 11.2798 5.75 11.625C5.75 11.9702 6.02981 12.25 6.375 12.25H10.125C10.4702 12.25 10.75 11.9702 10.75 11.625C10.75 11.2798 10.4702 11 10.125 11Z",
    fill: "#53AEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 1.25C11.0298 1.25 10.75 1.52981 10.75 1.875C10.75 2.22019 11.0298 2.5 11.375 2.5C11.7196 2.5 12 2.78038 12 3.125V14.125C12 14.4696 11.7196 14.75 11.375 14.75H2.625C2.28038 14.75 2 14.4696 2 14.125V3.125C2 2.78038 2.28038 2.5 2.625 2.5H4.6075C4.8655 3.22744 5.56022 3.75 6.375 3.75H7.625C8.65887 3.75 9.5 2.90887 9.5 1.875C9.5 0.841125 8.65887 0 7.625 0H6.375C5.56022 0 4.86553 0.522563 4.6075 1.25H2.625C1.59113 1.25 0.75 2.09113 0.75 3.125V14.125C0.75 15.1589 1.59113 16 2.625 16H11.375C12.4089 16 13.25 15.1589 13.25 14.125V3.125C13.25 2.09113 12.4089 1.25 11.375 1.25ZM6.375 1.25H7.625C7.96962 1.25 8.25 1.53038 8.25 1.875C8.25 2.21962 7.96962 2.5 7.625 2.5H6.375C6.03038 2.5 5.75 2.21962 5.75 1.875C5.75 1.53038 6.03038 1.25 6.375 1.25Z",
    fill: "#53AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderManagementLight);
export default __webpack_public_path__ + "static/media/orderManagement_light.f90ccfcc7245e2603f0776bb7497351a.svg";
export { ForwardRef as ReactComponent };